import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";

export const ShareNotice = ({
  children,
  title = t("momentum_modal.share_broadcast.title"),
  description = t("momentum_modal.share_broadcast.description"),
}: Readonly<{
  children: ReactNode;
  title?: string;
  description?: string;
}>) => (
  <div className="bg-secondary flex flex-col gap-y-7 rounded-lg p-6 text-center items-center">
    <div className="flex flex-col gap-y-2 px-4">
      <Typography variant="label-md">{title}</Typography>
      <Typography variant="body-sm" color="secondary">
        {description}
      </Typography>
    </div>
    {children}
  </div>
);
